import React, { ReactElement } from "react";
import { MenuItem } from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Link } from "@kameleon-common/gatsby-link";

export type DropdownSmallProps = {
  menuItems: MenuItem[];
};

const defaultProps = Object.freeze({});

export const DropdownSmall = ({
  menuItems,
}: DropdownSmallProps): ReactElement => (
  <Variants.Dropdown as="nav" className="navbar1_dropdown-list w-dropdown-list">
    {menuItems.map((menuItem, i) => {
      const key = `dropdown-link--${i}`;
      return (
        <Link
          key={key}
          to={menuItem.link}
          activeClassName="navbar1_dropdown-link--active"
          className="navbar1_dropdown-link w-dropdown-link"
        >
          {menuItem.label}
        </Link>
      );
    })}
  </Variants.Dropdown>
);

DropdownSmall.defaultProps = defaultProps;
